export default "__VITE_ASSET__Bt$9W8nt__"